"use client";

import { useId, useState, type ReactNode } from "react";
import { cn } from "../cn";

export interface TooltipProps {
  label: string;
  children: ReactNode;
  className?: string;
}

/** Hover/focus tooltip. The trigger wraps inline children; Escape dismisses. */
export function Tooltip({ label, children, className }: TooltipProps) {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <span
      className={cn("relative inline-flex", className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
      aria-describedby={open ? id : undefined}
    >
      {children}
      {open ? (
        <span
          role="tooltip"
          id={id}
          className="bg-charcoal text-cream text-caption absolute bottom-full left-1/2 z-50 mb-1.5 w-max max-w-xs -translate-x-1/2 rounded px-2 py-1 shadow-lg"
        >
          {label}
        </span>
      ) : null}
    </span>
  );
}
